<template>
    <main class="user-center">
        <div class="user-info flex flex-column flex-vertical-center flex-start">
            <div class="user-info-header flex flex-column flex-vertical-center flex-center">
                <p class="header-img">
                    <img :src="userInfo.avatar ? userInfo.avatar : defaultHeader" alt="" />
                </p>
                <!-- <span class="change-header">修改头像</span> -->
                <el-upload
                    class="upload-demo"
                    action="/api/signature/oss"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                    :http-request="fnOSSUpload"
                >
                    <el-button size="small" type="primary" class="change-header"
                        >修改头像</el-button
                    >
                </el-upload>
            </div>
            <ul>
                <li v-if="userInfo.idcard" class="user-info-item flex flex-vertical-center">
                    <label class="user-info-item-label">证件号</label>
                    <input
                        type="text"
                        class="user-info-item-input"
                        :value="userInfo.idcard"
                        disabled
                    />
                </li>
                <li class="user-info-item flex flex-vertical-center">
                    <label class="user-info-item-label">手机号</label>
                    <input
                        type="text"
                        class="user-info-item-input"
                        :value="userInfo.cellphone"
                        disabled
                    />
                </li>
                <li
                    class="user-info-item flex flex-vertical-center flex-column user-info-item-password"
                >
                    <div class="flex">
                        <label class="user-info-item-label">密码</label>
                        <input
                            type="password"
                            class="user-info-item-input"
                            :value="password"
                            disabled
                        />
                    </div>
                    <span class="change-password" @click="changePassword">修改密码</span>
                </li>
                <li class="user-info-item flex flex-vertical-center">
                    <label class="user-info-item-label">真实姓名</label>
                    <input
                        type="text"
                        class="user-info-item-input"
                        :value="userInfo.real_name"
                        disabled
                    />
                </li>
                <li class="user-info-item flex flex-vertical-center">
                    <label class="user-info-item-label">学校</label>
                    <input
                        type="text"
                        class="user-info-item-input"
                        :value="userInfo.school"
                        disabled
                    />
                </li>
                <li class="user-info-item flex flex-vertical-center">
                    <label class="user-info-item-label">年级</label>
                    <input
                        type="text"
                        class="user-info-item-input"
                        :value="num2CN[userInfo.grade - 1]"
                        disabled
                    />
                </li>
            </ul>
            <!-- <div class="save">
                    <hk-bottom text="保存" :customStyle="saveStyle"></hk-bottom>
                </div> -->
        </div>
        <div v-if="panelState" class="change-password-bg">
            <div class="change-panel">
                <i class="close-panel el-icon-close" @click="closePanel"></i>
                <p class="title">修改密码</p>
                <ul class="change-panel-content">
                    <li class="change-item flex flex-between">
                        <label class="change-item-label">旧密码</label>
                        <input v-model="oldPassword" type="password" class="change-item-input" />
                    </li>
                    <li class="change-item flex flex-between">
                        <label class="change-item-label">新密码</label>
                        <input
                            v-model="newPassword"
                            type="password"
                            class="change-item-input"
                            @blur="checkPassword"
                        />
                    </li>
                    <li class="change-item flex flex-between">
                        <label class="change-item-label">确认新密码</label>
                        <input
                            v-model="repeatPassword"
                            type="password"
                            class="change-item-input"
                            @blur="checkNewPwd"
                        />
                    </li>
                </ul>
                <div class="change-btns flex flex-center">
                    <hk-button
                        text="取消"
                        :customStyle="cancelStyle"
                        class="cancel"
                        @handleClick="closePanel"
                    ></hk-button>
                    <hk-button
                        text="确定"
                        :customStyle="confirmStyle"
                        class="confirm"
                        @handleClick="submitPassword"
                    ></hk-button>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import HkButton from '@components/HkButton';
import { mapGetters } from 'vuex';
import _axios from '@plugins/_axios';
import { randomString } from '@helpers/randomString';
import axios from 'axios';
import { updateUserInfo, updatePassword } from '@api/userInfo';
export default {
    components: {
        // HkScreen,
        HkButton
    },
    data() {
        return {
            num2CN: [
                '一年级',
                '二年级',
                '三年级',
                '四年级',
                '五年级',
                '六年级',
                '初一',
                '初二',
                '初三',
                '高一',
                '高二',
                '高三'
            ],
            defaultHeader: require('@images/base/header-exam.png'),
            password: '123456789',
            oldPassword: '',
            newPassword: '',
            repeatPassword: '',
            // saveStyle: {
            //     width: 110,
            //     color: '#fff',
            //     shadowColor: '#D695DE',
            //     background: true,
            //     startColor: '#CA2AD0',
            //     endColor: '#A90FBC'
            // }
            cancelStyle: {
                width: '110px',
                color: '#fff',
                shadowColor: '#FFC8A4',
                background: true,
                startColor: '#FF7B1A',
                endColor: '#FFA11A'
            },
            confirmStyle: {
                width: '110px',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#A90FBC',
                endColor: '#CA2AD0'
            },
            panelState: false,
            passwordReg: /^(?![^a-zA-Z]+$)(?!\D+$)\w{8,32}$/
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    created() {},
    mounted() {},
    methods: {
        changePassword() {
            this.panelState = true;
        },
        closePanel() {
            this.panelState = false;
        },
        fnOSSUpload(options) {
            // const that = this;
            const timeString = new Date().getTime();
            _axios.post(`${options.action}`).then((res) => {
                if (res.code === 0) {
                    let uploadData = new FormData();
                    const fileName = `${timeString}${randomString(6)}.${
                        options.file.name.split('.')[1]
                    }`;
                    uploadData.append('OSSAccessKeyId', res.data.accessid);
                    uploadData.append('policy', res.data.policy);
                    uploadData.append('Signature', res.data.signature);
                    uploadData.append('key', `${res.data.dir}${fileName}`);
                    uploadData.append('success_action_status', 200);
                    uploadData.append('name', fileName);
                    uploadData.append('file', options.file); // file必须放到最后
                    const config = {
                        headers: { 'Content-Type': 'multipart/form-data' },
                        onUploadProgress: (e) => {
                            if (e.total > 0) {
                                e.percent = (e.loaded / e.total) * 100;
                            }
                            options.onProgress(e);
                        }
                    };
                    axios
                        .post(res.data.url, uploadData, config)
                        .then(() => {
                            const path = `${res.data.dir}${fileName}`;
                            options.onSuccess(path, options.file);
                        })
                        .catch((error) => {
                            options.onError('图片上传失败');
                        });
                }
            });
        },
        handleAvatarSuccess(res, file) {
            // this.imageUrl = window.URL.createObjectURL(file.raw);
            updateUserInfo({ avatar: res }).then((result) => {
                if (result.code === 0) {
                    this.$store.dispatch('queryUserInfo');
                }
            });
        },
        beforeAvatarUpload(file) {
            const isImg = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isImg) {
                this.$message.error('上传图片只能是jpg、jpeg、png格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isImg && isLt2M;
        },
        checkNewPwd() {
            const { repeatPassword, newPassword } = this;
            if (repeatPassword !== newPassword) {
                this.$message.error('两次密码不一致！');
            }
        },
        checkPassword() {
            const { passwordReg, newPassword } = this;
            if (!passwordReg.test(newPassword)) {
                this.$message.error('请设置8~32位的数字、字母组合密码');
            }
        },
        submitPassword() {
            const { oldPassword, newPassword } = this;
            updatePassword(oldPassword, newPassword).then((res) => {
                if (res.code === 0) {
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    this.panelState = false;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.user-center {
    background: #f7f6f6;
    .user-info {
        width: 960px;
        min-height: calc(100vh - 253px);
        padding: 50px 0;
        background-color: #fff;
        border-radius: 0px 24px 0px 0px;
        &-header {
            margin: 0 0 26px 100px;
            .header-img {
                width: 73px;
                height: 73px;
                border: 1px solid #e0e0e0;
                border-radius: 50%;
                overflow: hidden;
                margin-bottom: 14px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .change-header {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #1a8bff;
                cursor: pointer;
                background-color: transparent;
                border: none;
            }
        }
        &-item {
            margin-bottom: 15px;
            &-password {
                align-items: flex-end;
            }
            &-label {
                box-sizing: border-box;
                width: 85px;
                line-height: 44px;
                padding-left: 18px;
                background: url('~@images/base/import-icon.png') no-repeat left center;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #322d33;
                margin-right: 5px;
            }
            &-input {
                box-sizing: border-box;
                width: 368px;
                height: 44px;
                border: none;
                border-radius: 22px;
                padding: 0 32px;
                background: #f0f0f0;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #bfbdc0;
            }
            .change-password {
                display: block;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #1a8bff;
                margin: 10px 0 25px 0;
                cursor: pointer;
            }
        }
    }
    .change-password-bg {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        .change-panel {
            box-sizing: border-box;
            width: 556px;
            height: 364px;
            background: #ffffff;
            border-radius: 20px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -228px;
            margin-top: -182px;
            padding: 39px 58px 33px 54px;
            .close-panel {
                position: absolute;
                top: 30px;
                right: 29px;
                color: #636363;
                font-weight: bold;
                cursor: pointer;
            }
            .title {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #333333;
                margin-bottom: 30px;
                text-align: center;
            }
            .change-item {
                margin-bottom: 15px;
                &-label {
                    box-sizing: border-box;
                    width: 100px;
                    line-height: 44px;
                    padding-left: 13px;
                    background: url('~@images/base/import-icon.png') no-repeat left center;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #322d33;
                    margin-right: 5px;
                }
                &-input {
                    box-sizing: border-box;
                    width: 330px;
                    height: 44px;
                    border-radius: 22px;
                    border: none;
                    background: #f0f0f0;
                    padding: 0 30px;
                    color: #333;
                    font-size: 16px;
                    outline: none;
                }
            }
            .change-btns {
                margin-top: 40px;
                .cancel {
                    margin-right: 20px;
                }
            }
        }
    }
}
</style>
